module.exports = __webpack_public_path__ + "img/facebook.4adc21de.svg";